
<section
  class="w-full flex flex-row justify-center bg-themeComponentBg-light font-rubik cover-cards-outer-container"
  aria-labelledby="cover-cards-heading"
>
  <!-- Visually hidden heading to label the section for crawlers / screen readers -->
  <h2 id="cover-cards-heading" class="sr-only">
    Steps to get your shipping container
  </h2>

  <div
    class="w-full max-w-1440 cover-cards-container mx-5 flex flex-col lg:flex-row gap-1"
    role="list"
  >
    <Card
      v-for="data in cardsData"
      :key="data.title"
      :data="data"
      class="w-full"
      role="listitem"
    />
  </div>
</section>
